import { TrackingCommand } from './TrackingInterface'
import {
  PageSetupCommand,
  TrackEventCommand,
  LocationSearchOpenedEventCommand,
  LocationSearchSubmittedFreeEventCommand,
  LocationSearchSubmittedSuggestionEventCommand,
  NavigationClickedEventCommand,
  TeaserClickedEventCommand,
  TeaserViewedEventCommand,
} from './TrackingCommands'

export class TrackingFactory {
  static createCommand(type: string): TrackingCommand {
    switch (type) {
      case 'page-setup':
        return new PageSetupCommand()
      case 'track-event':
        return new TrackEventCommand()
      case 'location-search-opened':
        return new LocationSearchOpenedEventCommand()
      case 'location-search-submitted-free':
        return new LocationSearchSubmittedFreeEventCommand()
      case 'location-search-submitted-suggestion':
        return new LocationSearchSubmittedSuggestionEventCommand()
      case 'navigation-clicked':
        return new NavigationClickedEventCommand()
      case 'teaser_clicked':
        return new TeaserClickedEventCommand()
      case 'teaser_viewed':
        return new TeaserViewedEventCommand()
      default:
        throw new Error(`Unknown tracking command type: ${type}`)
    }
  }
}
